import type { Edge2d } from "@logic/lib/mesh"

import type { TransactionOperation } from "."
import { areaIndex } from "../areas"

export const getAreaIdsOfEdge: TransactionOperation<Edge2d, string[]> = (
  { get },
  { node1id, node2id },
) =>
  get(areaIndex).filter(
    (areaId) => areaId.includes(node1id) && areaId.includes(node2id),
  )
